import { Injectable, OnDestroy } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DataShareService implements OnDestroy{
  private itemSource = new BehaviorSubject(null);
  currentItem = this.itemSource.asObservable();
  private destroy$ = new Subject<void>();
  constructor() {}

  change(val:any) {
    this.itemSource.next(val);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
